import { render, staticRenderFns } from "./OverviewDomainsTable.vue?vue&type=template&id=cb68cf8a"
import script from "./OverviewDomainsTable.vue?vue&type=script&lang=js"
export * from "./OverviewDomainsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports